export default __webpack_public_path__ + "static/media/expand.77992a8a.svg";